const LABELS = {
  "1": "Enfermaria",
  "2": "Apartamento",
};

export function tipoAcomodacaoOptions() {
  return Object.keys(LABELS).map((id) => ({
    id,
    nome: LABELS[id],
    label: formatTipoAcomodacao(id),
  }));
}

/** Exibição padronizada: "1 - Enfermaria" */
export function formatTipoAcomodacao(value) {
  if (value == null || value === "") {
    return "";
  }
  const id = String(value).trim();
  const nome = LABELS[id];
  if (nome) {
    return `${id} - ${nome}`;
  }
  return id;
}
